import { FleetDocumentUpload } from "../documents/types";
import { transformFleetVehicle } from "../transformations";
import {
  DamageStatus,
  DamagePin,
  FleetVehicleDamage,
  FleetVehicleDamageEditFormValues,
  FleetVehicleDamageRow,
  FleetVehicleDamageUploadRow,
} from "./types";

export const transformDamagePin = (res: any): DamagePin => {
  return {
    id: res.id,
    vehicleDamageStatusId: res.vehicleDamageStatusId,
    vehicleDamageStatusName: res.vehicleDamageStatusName,
    vehicleDamageStatusColor: res.vehicleDamageStatusColor,
    uploadId: res.uploadId,
    uploadUrl: res.uploadUrl,
    pinX: res.pinX,
    pinY: res.pinY,
    name: res.name,
    description: res.description,
  };
};

export const transformFleetVehicleDamageRow = (
  res: any
): FleetVehicleDamageRow => {
  const pins: DamagePin[] = res.pins
    ? res.pins.map(transformDamagePin)
    : [];

  return {
    id: res.id,
    name: res.name,
    description: res.description,
    damageDate: res.damageDate,
    vehicleDamageStatus: res.vehicleDamageStatus,
    pinImageId: res.pinImageId,
    pinImageUrl: res.pinImageUrl,
    pinX: res.pinX,
    pinY: res.pinY,
    created: res.created,
    pins,
    photoUploads: res.photoUploads ?? [],
    vehicle: res.vehicle ? transformFleetVehicle(res.vehicle) : null,
    // Razlaganje retka pokazuje pojedine oznake štete, ne priložene datoteke.
    childRows: pins,
  };
};

export const transformFleetVehicleDamage = (
  res: any
): FleetVehicleDamage => {
  return {
    id: res.id,
    vehicle: res.vehicle,
    vehicleDamageStatus: res.vehicleDamageStatus,
    name: res.name,
    description: res.description,
    damageDate: res.damageDate,
    pinImageId: res.pinImageId,
    pinImageUrl: res.pinImageUrl,
    pinX: res.pinX,
    pinY: res.pinY,
    created: res.created,
    uploads: res.uploads ?? [],
    photoUploads: res.photoUploads ?? [],
    documentUploads: res.documentUploads ?? [],
    pins: res.pins ? res.pins.map(transformDamagePin) : [],
  };
};

export const transformFleetVehicleDamageEditFormValues = (
  res: FleetVehicleDamage
): FleetVehicleDamageEditFormValues => {
  return {
    id: res.id,
    vehicleId: res.vehicle?.id,
    name: res.name,
    description: res.description,
    damageDate: res.damageDate,
    pins: (res.pins ?? []).map((p) => ({
      id: p.id,
      tempId: p.id ?? crypto.randomUUID(),
      vehicleDamageStatusId: p.vehicleDamageStatusId,
      uploadId: p.uploadId,
      pinX: p.pinX,
      pinY: p.pinY,
      name: p.name,
      description: p.description,
    })),
    photoUploads: res.photoUploads ?? [],
    documentUploads: res.documentUploads ?? [],
  };
};

export const transformFleetVehicleDamageOnCreate = (
  vehicleId: string,
  formValues: FleetVehicleDamageEditFormValues,
  photoUploads: FleetDocumentUpload[],
  documentUploads: FleetDocumentUpload[]
): any => ({
  vehicleId: vehicleId,
  vehicleDamageStatusId: "reported",
  name: formValues.name,
  description: formValues.description,
  damageDate: formValues.damageDate,
  pins: formValues.pins.map((p) => ({
    vehicleDamageStatusId: p.vehicleDamageStatusId,
    uploadId: p.uploadId,
    pinX: p.pinX,
    pinY: p.pinY,
    name: p.name,
    description: p.description,
  })),
  photoUploadIds: photoUploads.map((u) => u.id),
  documentUploadIds: documentUploads.map((u) => u.id),
});

export const transformFleetVehicleDamageOnUpdate = (
  formValues: FleetVehicleDamageEditFormValues,
  photoUploads: FleetDocumentUpload[],
  documentUploads: FleetDocumentUpload[]
): any => ({
  vehicleDamageStatusId: "reported",
  name: formValues.name,
  description: formValues.description,
  damageDate: formValues.damageDate,
  pins: formValues.pins.map((p) => ({
    vehicleDamageStatusId: p.vehicleDamageStatusId,
    uploadId: p.uploadId,
    pinX: p.pinX,
    pinY: p.pinY,
    name: p.name,
    description: p.description,
  })),
  photoUploadIds: photoUploads.map((u) => u.id),
  documentUploadIds: documentUploads.map((u) => u.id),
});

export const transformDamageStatus = (res: any): DamageStatus => {
  return {
    id: res.id,
    name: res.name,
    color: res.color,
  };
};

export const transformFleetVehicleDamageUploadRow = (
  res: any,
  parent: any
): FleetVehicleDamageUploadRow => {
  return {
    vehicleDamageId: parent.id,
    id: res.id,
    originalFileName: res.originalFileName,
    created: res.created,
    url: res.url,
  };
};
